import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [expiredNotice, setExpiredNotice] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    login,
    isAuthenticated
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // Check if already authenticated and redirect to orders page
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/orders');
    }
  }, [isAuthenticated, navigate]);

  // Show a clear message if session expired and we were redirected here
  useEffect(() => {
    try {
      if (sessionStorage.getItem('auth_expired') === '1') {
        setExpiredNotice('Your session has expired. Please log in again.');
      }
    } catch {}
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setExpiredNotice('');
    setIsLoading(true);
    // Add validation
    if (!email || !password) {
      setError('Email and password are required');
      setIsLoading(false);
      return;
    }
    try {
      console.log('Attempting login with:', email); // Debug log
      const success = await login(email, password);
      console.log('Login success:', success); // Debug log
      if (success) {
        // Clear the expired flags and optionally restore previous route
        try {
          sessionStorage.removeItem('auth_expired');
          const redirectTo = sessionStorage.getItem('auth_expired_path');
          sessionStorage.removeItem('auth_expired_path');
          if (redirectTo && redirectTo !== '/login') {
            navigate(redirectTo, { replace: true });
          } else {
            navigate('/orders', { replace: true });
          }
        } catch {
          navigate('/orders', { replace: true });
        }
      } else {
        setError('Invalid email or password');
      }
    } catch (err) {
      console.error('Login error:', err); // Debug log
      setError('An error occurred during login. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  // Auto-fill demo credentials for easier testing
  const fillDemoCredentials = (role: 'admin' | 'support') => {
    if (role === 'admin') {
      setEmail('admin@example.com');
      setPassword('admin123');
    } else {
      setEmail('support@example.com');
      setPassword('support123');
    }
  };
  return <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            E-SIM Management
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Sign in to your account
          </p>
        </div>
        {!!expiredNotice && (
          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4">
            <div className="flex">
              <div className="ml-3">
                <p className="text-sm text-yellow-700">{expiredNotice}</p>
              </div>
            </div>
          </div>
        )}
        {error && <div className="bg-red-50 border-l-4 border-red-500 p-4">
            <div className="flex">
              <div className="ml-3">
                <p className="text-sm text-red-700">{error}</p>
              </div>
            </div>
          </div>}
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input id="email-address" name="email" type="email" autoComplete="email" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-alps-primary focus:border-alps-primary focus:z-10 sm:text-sm" placeholder="Email address" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input id="password" name="password" type="password" autoComplete="current-password" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-alps-primary focus:border-alps-primary focus:z-10 sm:text-sm" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
            </div>
          </div>
          <div>
            <button type="submit" disabled={isLoading} className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-alps-primary hover:bg-alps-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-alps-primary">
              {isLoading ? 'Signing in...' : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>;
};
